var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"w-16 h-7 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out",class:{ 'bg-green-500': _vm.value },on:{"click":_vm.toggle}},[_c('span',{staticClass:"bg-white w-8 h-5 rounded-full shadow-md transform duration-300 ease-in-out",class:{ 'translate-x-6': _vm.value }})])
}
var staticRenderFns = []

export { render, staticRenderFns }